var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#0D2240;}\r\n\t.st2{fill:#FFA400;}\r\n\t.st3{fill:#2B5134;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.9,255.1h-22.7l30.9-70.9h22.9C289.3,222.2,280,243.3,274.9,255.1 M200.4,249.2l-19.7-65.1h48.3 C214.7,216.6,205.8,236.7,200.4,249.2 M131.5,228.4l5.2-12l3.6,12H131.5z M329.4,255.1l38.8-89l-180.2,0l-7.5,17.2l-5.2-17.2 l-36.1,0c0,0-23.8,54.3-30.6,69.9c0.6-3.1,1-6.4,1-9.7c0-0.4,0-0.9,0-1.3c2.7-6.1,23.7-54.3,28-64.1h99l21.2-48.6H140.4l-38.5,88.2 c-8.5-13.4-23.5-22.2-40.5-22.2c-26.6,0-48.1,21.5-48.1,48.1c0,26.6,21.5,48.1,48.1,48.1c16.2,0,30.4-8,39.2-20.2l-8.2,18.9h19.7 l11.6-26.6h22.2l8,26.6h207.4l7.9-18.1H329.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2,228.5c0.6,11.9,5.7,22.5,13.7,30.3c8.5-7.5,14.1-18.3,14.7-30.3H16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,228.5c-0.6,13.1-6.5,24.8-15.6,33c7.3,5.9,16.4,9.6,26.5,10.1v-43H48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2,224.5h28.4c-0.5-12.2-6.1-23.1-14.7-30.6C21.8,201.7,16.7,212.5,16.2,224.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.9,191.2c9.2,8.3,15.1,20.1,15.6,33.3h10.8v-43.4C49.3,181.6,40.2,185.3,32.9,191.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.4,228.5H78.1c0.6,12.1,6.2,22.8,14.7,30.3C100.7,251,105.9,240.4,106.4,228.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.1,228.5H63.3v43c10-0.4,19.2-4.1,26.5-10.1C80.6,253.2,74.7,241.5,74.1,228.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.8,191.2c-7.3-5.9-16.4-9.6-26.5-10.1v43.4h10.8C74.6,211.3,80.6,199.5,89.8,191.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.2,115.1L102.1,207c-2.3-4.9-5.5-9.4-9.4-13.1c-8.6,7.6-14.2,18.4-14.7,30.6h28.4l29-66.5h84.8l18.7-42.9 H142.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "234.5,158 253.2,115.1 245.2,115.1 226.5,158  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,231.3c3.3-7.6,6.8-15.5,10.1-23.1l7,23.1H127.1z M155.9,270.3h33.7L159.2,169h-18.2L96.5,270.3H110 c0,0,5-11.4,11.7-26.6h26.2L155.9,270.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "192.7,260.1 197.4,249.4 173,169 165,169  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.6,257.9l39-88.9l-56.7,0l-5.4,12.3h22.9c-11.8,27-39,88.9-39,88.9l88,0l5.4-12.3H310.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "250.3,252.2 286.6,169 278.6,169 242.3,252.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "327.5,252.2 363.8,169 355.8,169 319.5,252.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.5,169h-82.7l-5.4,12.3h48.9c-11.8,27-39,88.9-39,88.9l71.3,0l5.4-12.3h-37.4L272.5,169z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.3,151.4h-10.5l16-36.3H266l-16.6,37.5c-1.3,2.9,0,5.3,3,5.3h15.3c2.9,0,6.4-2.4,7.7-5.3l16.6-37.5h-7.6 L268.3,151.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "326,115.1 299,115.1 296.1,121.7 306.6,121.7 290.6,158 298.3,158 314.3,121.7 323.1,121.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.5,115.1h-7.6L308.8,158h7.3l4.3-6.5h10.3l-1.5,6.5h7.7L345.5,115.1z M336.8,125.8l-4.5,18.8h-7.5 L336.8,125.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "380.1,115.1 372.1,133.2 361.7,133.2 369.7,115.1 361.9,115.1 343,158 350.7,158 358.7,139.8 369.2,139.8 361.2,158 368.9,158 387.8,115.1  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUta);
export default __webpack_public_path__ + "static/media/UTA.9edc3ea3eb1e1ac7d4530704671dee9d.svg";
export { ForwardRef as ReactComponent };